import { createRouter, createWebHistory } from "vue-router";
import { routes } from "vue-router/auto-routes";
import { useSessionStore } from "@/store/session";

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.afterEach((to, from) => {
	setTimeout(() => {
		window.scroll({
			top: 0,
			behavior: "instant",
		});
	}, 100);
});

router.beforeEach((to, from, next) => {
	const sessionStore = useSessionStore();
	console.log(sessionStore.isLoggedIn);
	if (!sessionStore.isLoggedIn) {
		if (to.name !== "LoginPage") {
			next({ name: "LoginPage" });
		} else {
			next();
		}
	} else {
		next();
	}

	// if (!sessionStore.isLoggedIn) {
	// 	if (to.name !== "LoginPage") {
	// 		next({ name: "LoginPage" });
	// 	} else {
	// 		next();
	// 	}
	// } else if (to.name === "ManageUsers") {
	// 	if (!sessionStore.can("view-all-users")) {
	// 		next({ name: "CreatePost" });
	// 	} else {
	// 		next();
	// 	}
	// } else if (to.name === "CreatePost") {
	// 	if (!sessionStore.can("create-post")) {
	// 		next({ name: "LoginPage" });
	// 	} else {
	// 		next();
	// 	}
	// } else if (to.name === "EditPosts") {
	// 	if (!sessionStore.can("edit-post")) {
	// 		next({ name: "CreatePost" });
	// 	} else {
	// 		next();
	// 	}
	// } else {
	// 		next();
	// 	}
});

export default router;
